/*
 *  Copyright (c) 2018-present, Evgeny Nadymov
 *
 * This source code is licensed under the GPL v.3.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createTheme } from '@mui/material/styles';

// Create a theme instance with colors matching the current design
const muiTheme = createTheme({
    palette: {
        primary: {
            main: '#3b82f6', // Current blue color used in the app
            light: '#ebf5ff',
            dark: '#2563eb',
        },
        secondary: {
            main: '#6b7280',
            light: '#9ca3af',
            dark: '#4b5563',
        },
        background: {
            default: '#f5f5f5',
            paper: '#ffffff',
            hover: '#f9fafb',
        },
        text: {
            primary: '#1f2937',
            secondary: '#6b7280',
            disabled: '#9ca3af',
        },
        error: {
            main: '#E53935',
            light: 'rgba(239, 68, 68, 0.2)',
        },
        success: {
            main: '#4DCD5E',
        },
        divider: '#e5e7eb',
        action: {
            hover: 'rgba(0, 0, 0, 0.04)',
        },
    },
    shape: {
        borderRadius: 8,
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        button: {
            textTransform: 'none',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none',
                    },
                },
                contained: {
                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                    '&:hover': {
                        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                    },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                    borderRadius: 12,
                },
            },
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                    borderRadius: '8px !important',
                    '&:before': {
                        display: 'none',
                    },
                    '&.Mui-expanded': {
                        margin: '16px 0',
                    },
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    minHeight: 60,
                    padding: '0 16px',
                },
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    padding: 16,
                    borderTop: '1px solid #e5e7eb',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 9999,
                },
            },
        },
    },
});

export default muiTheme;
